import Link from 'next/link'
import { Fragment } from 'react'
import PropTypes from 'prop-types'

const IndexList = (props) => {
  const { leftList, rightList } = props
  const parseAnchor = (link) => (link[0] !== '#' ? `#${link}` : link)

  const generateColumn = (column, num) => {
    return (
      <div className="IndexList-column">
        <ul className="IndexList-list">
          {column.map((listItem, index) => {
            return (
              <Fragment key={`IndexList-listItem--${num}${index}`}>
                {listItem.anchor && (
                  <li className="IndexList-listItem">
                    <a className="IndexList-link" href={listItem.anchor ? parseAnchor(listItem.anchor) : '#'}>
                      {listItem.label}
                    </a>
                  </li>
                )}
                {!listItem.anchor && listItem.link && listItem.link.length > 0 && (
                  <li className="IndexList-listItem" key={`IndexList-listItem--${num}${index}`}>
                    <Link href={`/${listItem.link[0].uri}`}>
                      <a className="IndexList-link">{listItem.label}</a>
                    </Link>
                  </li>
                )}
              </Fragment>
            )
          })}
        </ul>
      </div>
    )
  }

  return (
    <div className="IndexList">
      <div className="IndexList-inner">
        {generateColumn(leftList, 1)}
        {generateColumn(rightList, 2)}
      </div>
    </div>
  )
}

IndexList.propTypes = {
  leftList: PropTypes.array,
  rightList: PropTypes.array
}

export default IndexList
